/// <amd-module name="Wit/WorkItemForm/Common/Components/WorkItemFieldSubscriber" />
import { useWorkItem } from "Wit/WorkItemForm/Common/Hooks";
import { WorkItemWatermarkAllAction } from "Wit/WorkItemModel/OM";
import { useEffect } from "react";

export interface IWorkItemFieldSubscriberProps {
    asIdentityRef?: boolean;
    fieldId: number;
    onUpdate: (value: any) => void;
    original?: boolean;
}

/**
 * Subscribes to a fieldId changing and the WorkItemWatermarkAllAction action and calls the onUpdate
 * function with the value from the model
 */
export function WorkItemFieldSubscriber({ asIdentityRef, fieldId, onUpdate, original }: IWorkItemFieldSubscriberProps) {
    const workItem = useWorkItem();

    useEffect(() => {
        const handleUpdate = () => {
            onUpdate(workItem.getFieldValueById(fieldId, original, false, asIdentityRef));
        };

        workItem.getFieldWatermark().subscribe(handleUpdate, fieldId.toString());
        workItem.getFieldWatermark().subscribe(handleUpdate, WorkItemWatermarkAllAction);

        return () => {
            workItem.getFieldWatermark().unsubscribe(handleUpdate, fieldId.toString());
            workItem.getFieldWatermark().unsubscribe(handleUpdate, WorkItemWatermarkAllAction);
        };
    }, [fieldId, onUpdate, original]);

    return null;
}

export interface IMultiWorkItemFieldSubscriberProps {
    fieldIds: number[];
    onUpdate: (updateNumber: number, action?: string) => void;
}

/**
 * Subscribes to a set of fieldIds and the WorkItemWatermarkAllAction action and calls the onUpdate function.
 * This should be used if you have a control that is dependent on multiple fields.
 */
export function MultiWorkItemFieldSubscriber({ fieldIds, onUpdate }: IMultiWorkItemFieldSubscriberProps) {
    const workItem = useWorkItem();

    useEffect(() => {
        fieldIds.forEach(fieldId => {
            workItem.getFieldWatermark().subscribe(onUpdate, fieldId.toString());
        });
        workItem.getFieldWatermark().subscribe(onUpdate, WorkItemWatermarkAllAction);

        return () => {
            fieldIds.forEach(fieldId => {
                workItem.getFieldWatermark().unsubscribe(onUpdate, fieldId.toString());
            });
            workItem.getFieldWatermark().unsubscribe(onUpdate, WorkItemWatermarkAllAction);
        };
    }, [fieldIds, onUpdate]);

    return null;
}
